import * as core from '../../../../../../../core'

import { query } from './stakeholder-details.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholder.details',
    description: 'Details view for a stakeholder',
    name: 'Stakeholder Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
